import { useEffect, useState } from "react";

import { Button, Card, Grid } from "@material-ui/core";
import { AirportShuttle, Assignment, PeopleAltOutlined, Receipt, Search } from "@material-ui/icons";

import { useTraslados } from "../../../hooks/useCases/useTraslados";
import { useValidationForm } from "../../../hooks/useValidationForm";
import { GenericStepperForm } from "../../atomic/organisms/GenericStepper";
import { useFormNew } from "../../../hooks/useFormNew";
import { SearchAfiliadoTraslados } from "./SearchAfiliadoTraslados";
import { DatosTitularTraslado } from "./DatosTitularTraslado";
import { DatosSolicitudTraslado } from "./DatosSolicitudTraslado";
import { DocumentacionDiagnosticoTraslado } from "./DocumentacionDiagnosticoTraslado";
import { DatosTraslado } from "./DatosTraslado";
import { compararObjetos } from "../../../helpers/arrays";
import { initTrasladosValues, sendSolicitudValues, sendTrasladosValues } from "../data/formTrasladoData";
import { GenericModal } from "../../atomic/organisms/GenericModal";
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
  
export const CargaSolicitudTraslados = ({ solicitud, resetRedirect }) => {
  const validations = useValidationForm();
  const { put, post, data } = useTraslados();

  const initValues = initTrasladosValues(data.dim.tipoSolicitudes[0], solicitud);
  const { formValues, setFormValues, handleInputChange } = useFormNew(initValues);
  const [solicitudCopy, setSolicitudCopy] = useState(solicitud ? initValues : null);
  const [modalNuevaCarga, setModalNuevaCarga] = useState(false)
  const [redirect, setRedirect] = useState(false)

  useEffect(() => {
    if(solicitud) resetRedirect();
  }, []);

  const solicitudSend = sendSolicitudValues(formValues);
  const copySolicitudSend = sendSolicitudValues(solicitudCopy);

  return (
    <>
      <GenericStepperForm
        Banner={(
          <Card
            elevation={3}
            style={{
              width: "100%",
              margin: "auto",
              textAlign: "center",
              backgroundColor: formValues.afiliado?.fecha_baja ? "red" : "green",
              color: "white",
              fontWeight: "bold",
              fontSize: "1em",
              padding: "0.25rem 0",
            }}
          >
            {`${formValues.afiliado?.apellido_y_nombre} / CUIL: ${formValues.afiliado?.cuil} `}
            {formValues?.id && (
              `/ N° Orden: ${formValues?.id}`
            )}
          </Card>
        )}
        steps={[
          // BUSCAR TITULAR
          {
            stepLabel: "Buscar Titular",
            Component: (
              <SearchAfiliadoTraslados 
                afiliado={formValues.afiliado} 
                setAfiliado={(afiliado) => setFormValues({ ...formValues, afiliado, idAfiliado: afiliado?.id_afiliado || "" })} 
              />
            ),
          },

          // DATOS DEL TITULAR
          {
            Component: (
              <DatosTitularTraslado {...{ formValues, setFormValues }} />
            ),
            stepLabel: "Datos del Titular",
            stepBanner: true,
            handleClickNext: (handleNext) => {
              put.afiliaciones.contactoAfiliado({
                idAfiliado: formValues.afiliado.id_afiliado,
                mail: formValues.afiliado.domiciliosAfiliados.mail,
                telefono: formValues.afiliado.domiciliosAfiliados.telefono,
                celular: formValues.afiliado.domiciliosAfiliados.celular,
              }, () => handleNext());
            },
            handleClickBack: (setActive) => {
              setFormValues(initTrasladosValues(data.dim.tipoSolicitudes[0]));
              setActive();
            }
          },

          // DATOS DE LA SOLICITUD
          {
            Component: (
              <DatosSolicitudTraslado {...{ formValues, handleInputChange, setFormValues }} />
            ),
            stepLabel: "Datos de la Solicitud",
            stepBanner: true,
            initStep: solicitud,
            handleClickNext: (handleNext) => {
              if(validations([
                {
                  errorCondition: formValues.practica === null,
                  errorMessage: "Debe ingresar una practica"
                },
                {
                  errorCondition: formValues.efector === null,
                  errorMessage: "Debe ingresar un efector"
                },
              ])){
                if(!formValues.id)
                  post.solicitud(solicitudSend, setFormValues, () => handleNext(), formValues);
              
                else if(compararObjetos(solicitudSend, copySolicitudSend).length > 0 && formValues.id)
                  put.solicitud(solicitudSend, formValues, setFormValues, setSolicitudCopy, () => handleNext());

                else handleNext();
              }
            },
          },

          // DIAGNOSTICO Y DOCUMENTACION
          {
            Component: (
              <DocumentacionDiagnosticoTraslado {...{ formValues, setFormValues }} />
            ),
            stepLabel: "Diagnostico y Documentación",
            stepBanner: true,
            handleClickNext: (handleNext) => {
              if(validations([
                {
                  errorCondition:!formValues.diagnostico,
                  errorMessage: "Falta ingresar diagnostico"
                },
                {
                  errorCondition: data.tipoDocSolicitudes.filter(x => x.obligatorio).filter(({idTipoDoc}) => !formValues.documentacion.some(d => d.idTipoDoc === idTipoDoc)) > 0,
                  errorMessage: "Falta ingresar documentación"
                },
              ])){
                if(compararObjetos(copySolicitudSend, solicitudSend).length > 0)
                  put.solicitud(solicitudSend, formValues, setFormValues, setSolicitudCopy, () => handleNext(), "Documentación / Diagnostico Guardados");

                else handleNext();
              }
            },
          },

          // DATOS DE TRASLADO
          {
            stepLabel: "Datos de Traslado",
            stepBanner: true,
            Component: (
              <DatosTraslado {...{ formValues, setFormValues }} />
            ),
          },
        ]}
        stepIcons={{
          1: <Search />,
          2: <PeopleAltOutlined />,
          3: <Receipt />,
          4: <Assignment />,
          5: <AirportShuttle />,
        }}
        buttonLabelFinish="Confirmar"
        handleSubmit={(resetStepper) => {debugger; return put.traslado(
          sendTrasladosValues(formValues), 
          () => {
            resetStepper();
            setModalNuevaCarga(true)
          })}
        }
      />
      {
        modalNuevaCarga && (
          <GenericModal
            open={modalNuevaCarga}
            handleClose={()=> {
              setModalNuevaCarga(false)
              setFormValues(initTrasladosValues(data.dim.tipoSolicitudes[0]))
            }}
            title={`¿Desea cargar otro traslado para ${formValues.afiliado?.apellido_y_nombre}?`}
          >
            <Grid container justify="center" style={{marginTop: "1.5em"}}>
              <Button 
                variant="contained"
                color="primary"
                onClick={() => { 
                  setModalNuevaCarga(false)
                  setRedirect(formValues.afiliado?.id_afiliado)
                  setFormValues(initTrasladosValues(data.dim.tipoSolicitudes[0]))
                }}
              >
                Nueva Carga
              </Button>
            </Grid>
          </GenericModal>
        )
      }
      {
        redirect && (
          <Redirect
              to={{
                  pathname: '/traslados',
                  state:{
                      idAfiliado: redirect,
                  }       
              }}
          />
        )
      }
    </>
  )
}